import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
// import * as AWS from '@aws-sdk/client-cognito-identity-provider';
//import * as AWS from 'aws-sdk/global';

import {awsConfig} from '../../shared/config';
import * as RestURI from '../../shared/RestURI';
import * as ActionTypes from '../ActionTypes'
import * as AuthConstants from '../../utils/constants/AuthenticationConstants';
import * as AuthC from '../../utils/auth/AuthCognito';
import * as ValidationMessages from '../../components/constants/ValidationMessages';


const requestLogin = () => ({
    type: ActionTypes.LOGIN_REQUEST
});


const receiveLogin = (cognitoUser, afUser) => {
    return {
        type: ActionTypes.LOGIN_SUCCESS,
        payload: {
            cognitoUser: cognitoUser,
            afUser: afUser
        }
    }
}

const loginError = (message) => ({
    type: ActionTypes.LOGIN_FAILURE,
    message
});


const loginAuthenticationChallenge = (challenge, userAttributes, username, cognitoUser) => ({
    type: ActionTypes.LOGIN_AUTH_CHALLENGE,
    payload: {
        authChallenge: challenge,
        userAttributes: userAttributes,
        username: username,
        cognitoUser: cognitoUser
    }
});


const loginAuthenticationChallengeSuccess = () => ({
    type: ActionTypes.LOGIN_AUTH_CHALLENGE_SUCCESS
});


const loginAuthenticationChallengeFailure = (message) => ({
    type: ActionTypes.LOGIN_AUTH_CHALLENGE_FAILURE,
    message
});


export const loginUser = (creds, onLoginCallback) => (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(requestLogin());

    var cognitoUser = AuthC.getNewCognitoUser(creds.Username);

    // Authenticate against Cognito
    var authenticationData = {
        Username : creds.Username,
        Password : creds.Password,
    };
    var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);

    cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function (result) {
            console.log("> Login Success");

            var jwtIdToken = result.getIdToken().getJwtToken();

            fetchUserByUsername(creds.Username, jwtIdToken)
                .then(afUser => {
                    if(afUser == null) {
                        cognitoUser.signOut();

                        let error = new Error(ValidationMessages.INVALID_USER_OR_PASSWORD);
                        error.code = "USER_INVALID";
                        dispatch( loginError(error) );
                    }
                    else if(!afUser.generalSection.active) {
                        console.log("User inactiv");
                        cognitoUser.signOut();

                        let error = new Error(ValidationMessages.INACTIVE_USER);
                        error.code = "USER_INACTIV";
                        dispatch( loginError(error) );
                    }
                    else {
                        console.log("User Activ");

                        localStorage.setItem('afUser', JSON.stringify(afUser));
                        // Dispatch the success action
                        dispatch( receiveLogin(cognitoUser, afUser) );
                        onLoginCallback(afUser);
                    }
                })
                .catch(error => {
                    console.log("Error fetching user: " + error);
                    cognitoUser.signOut();
                    dispatch( loginError(error) );
                });
        },

        onFailure: function(err) {
            console.log("> Login Failure: " + err);
            dispatch( loginError(err) );
        },

        newPasswordRequired: function(userAttributes, requiredAttributes) {
            // User was signed up by an admin and must provide new
            // password and required attributes, if any, to complete
            // authentication.
 
            // the api doesn't accept this field back
            //delete userAttributes.email_verified;
 
            console.log(">>>>> Attribs: " + JSON.stringify(userAttributes));
            dispatch( loginAuthenticationChallenge(AuthConstants.FORCE_CHANGE_PASSWORD, userAttributes, creds.Username, cognitoUser) );
        }

    });
}


export const changePasswordChallenge = (credentials) => (dispatch, getState) => {

    const authState =  getState().auth;
    const cognitoUser = authState.cognitoState.cognitoUser;
    
    const userAttr = authState.cognitoState.userAttr;

    cognitoUser.completeNewPasswordChallenge(credentials.Password, userAttr, {
        onSuccess: result => {
          // login
          console.log("> Success change pswd");
          console.log(result);
          dispatch( loginAuthenticationChallengeSuccess() );
        },

        onFailure: err => {
            console.log("> Failure to change Pswd: " + err);          
            dispatch( loginAuthenticationChallengeFailure(err) );  
        }
      });
}


const requestLogout = () => {
    return {
        type: ActionTypes.LOGOUT_REQUEST
    }
}

const receiveLogout = () => {
    return {
        type: ActionTypes.LOGOUT_SUCCESS
    }
}

const requestStateReset = () => {
    return {
        type: ActionTypes.RESET_STATE_ON_LOGOUT
    }
}

// Logs the user out
export const logoutUser = () => (dispatch) => {
    console.log("> Logout");

    dispatch(requestLogout())

    AuthC.signOut();

    // Comment out for testing
    // ***********************
    localStorage.removeItem('afUser');
    // localStorage.removeItem('creds');
    //dispatch(favoritesFailed("Error 401: Unauthorized"));

    // dispatch(receiveLogout())
    dispatch(requestStateReset());
}


export const createUser = (user) => (dispatch) => {
    console.log("> CreateUser ");

    // const config = {
    //     //accessKeyId: awsConfig.authKey.accessKeyId,
    //     //accessSecretKey: awsConfig.authKey.accessKeySecret,
    //     //userPoolId: 'eu-central-1_QGAxqXeTU', 
    //     //userPoolClientId: '5chll45j25779ed1abmbu0c4e9',         
    //     region: awsConfig.cognito.region,
    //     endpointProvider: 'cognito-idp.eu-central-1.amazonaws.com',
    // };
    // //AWS.config.update(config);

    // // var cognitoIdentityServiceProvider = new AWS.CognitoIdentityServiceProvider();
    // var cognitoIdentityProvider = new AWS.CognitoIdentityProvider();
    // cognitoIdentityProvider.config = config;

    // // var cognitoIdentityProvider = new AWS.CognitoIdentityProviderClient(config);

    // // var client = new AWS.CognitoIdentityProviderClient();
    // // client.ad

    // var params = {
    //     UserPoolId: awsConfig.cognito.userPoolId, /* required */
    //     Username: 'florin.brinzan@bbfcomp.com', /* required */
    //     DesiredDeliveryMediums: [
    //         'EMAIL'
    //     ],
    //     TemporaryPassword: 'MyTempPswd#1',
    //     UserAttributes: [
    //         {
    //             Name: 'email', /* required */
    //             Value: 'florin.brinzan@bbfcomp.com'
    //         }
    //     ]
    // };    

    // console.log("calling....");
    // cognitoIdentityProvider.adminCreateUser(params, function (err, data) {
    //     if (err){ 
    //         // an error occurred
    //         console.log(">>>>>>>>> Error Creating User");
    //         console.log(err, err.stack);
            
    //     }
    //     else {
    //         // successful response
    //         console.log(">>>>>>>> Success Creating User");
    //         console.log(data); 
    //     }
    // });

}


// const s3Client = new S3Client({
//     region: REGION,
//     credentials: fromCognitoIdentityPool({
//       clientConfig: { region: REGION }, // Configure the underlying CognitoIdentityClient.
//       identityPoolId: 'IDENTITY_POOL_ID',
//       logins: {
//               // Optional tokens, used for authenticated login.
//           },
//     })
//   });



export const fetchUserByUsername = async (userName, jwtToken) => {
    const urlParams = new URLSearchParams({ userName: userName });
    const url = new URL(`${awsConfig.api.invokeUrl}${RestURI.USERS}?${urlParams}`);

    const bearer = 'Bearer ' + jwtToken;

    console.log("fetchUser: " + userName);

    return await fetch(url.href, {
        method: "GET",
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
        },
        credentials: "same-origin"
    })
        .then(response => {
            if (response.ok) {
                return response;
            } else {
                var error = new Error('Error ' + response.status + ': ' + response.statusText);
                error.response = response;
                throw error;
            }
        },
            error => {
                var errmess = new Error(error.message);
                throw errmess;
            })
        .then(response => response.json() )
        .catch(error => console.log(">>>> Error: " + error.message));
}


